import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { JOBS, CATEGORIES, LOCATIONS } from "./jobsData";

const Section3 = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [category, setCategory] = useState("");
  const [location, setLocation] = useState("");
  const [filters, setFilters] = useState({ searchTerm: "", category: "", location: "" });

  const filteredJobs = useMemo(() => {
    return JOBS.filter((job) => {
      const matchesSearch = job.title
        .toLowerCase()
        .includes(filters.searchTerm.trim().toLowerCase());
      const matchesCategory = !filters.category || job.category === filters.category;
      const matchesLocation = !filters.location || job.location === filters.location;
      return matchesSearch && matchesCategory && matchesLocation;
    });
  }, [filters]);

  const handleSearch = (e) => {
    e.preventDefault();
    setFilters({ searchTerm, category, location });
  };

  return (
    <section className="careers-section-3" id="careers-roles">
      <div className="container">
        <div className="join-team-head" data-aos="fade-up" data-aos-duration="900">
          <h2 className="title">
            Join <span className="yellow-txt">Our Team</span>
          </h2>
          <p className="desc">
            Explore open roles below and find where you can grow, build and
            make an impact with ExD Digital.
          </p>
        </div>

        {JOBS.length === 0 ? (
          <div className="open-roles" data-aos="fade-up" data-aos-duration="1100">
            <h3 className="open-roles-label">Open Roles</h3>

            <div className="no-openings">
              <p>No openings yet. Check back soon — new opportunities are on the way!</p>
            </div>
          </div>
        ) : (
          <>
            <form
              className="job-filter-bar"
              onSubmit={handleSearch}
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <input
                type="text"
                className="job-search-input"
                placeholder="Search for a job title"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />

              <select
                className="job-filter-select"
                value={category}
                onChange={(e) => setCategory(e.target.value)}
              >
                <option value="">Categories</option>
                {CATEGORIES.map((cat) => (
                  <option key={cat} value={cat}>
                    {cat}
                  </option>
                ))}
              </select>

              <select
                className="job-filter-select"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
              >
                <option value="">Locations</option>
                {LOCATIONS.map((loc) => (
                  <option key={loc} value={loc}>
                    {loc}
                  </option>
                ))}
              </select>

              <button type="submit" className="search-jobs-btn">
                Search Jobs
              </button>
            </form>

            <div className="open-roles" data-aos="fade-up" data-aos-duration="1100">
              <h3 className="open-roles-label">Open Roles</h3>

              <div className="open-roles-table-wrap">
                <table className="open-roles-table">
                  <thead>
                    <tr>
                      <th>Job Title</th>
                      <th>Category</th>
                      <th>Location</th>
                      <th>Type</th>
                      <th className="view-col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredJobs.length === 0 && (
                      <tr className="no-results-row">
                        <td colSpan={5}>No roles match your search right now. Try different filters.</td>
                      </tr>
                    )}
                    {filteredJobs.map((job) => (
                      <tr key={job.id}>
                        <td data-label="Job Title" className="job-title-cell">{job.title}</td>
                        <td data-label="Category">{job.category}</td>
                        <td data-label="Location">{job.location}</td>
                        <td data-label="Type">{job.type}</td>
                        <td data-label="" className="view-cell">
                          <button
                            className="view-btn"
                            onClick={() => navigate(`/careers/${job.id}`)}
                          >
                            View
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default Section3;
